import * as app     from './module/app.js';
import * as user from './module/user.js';
import * as robot from './module/robot.js';
import * as article from './module/article.js';
import * as survey from './module/survey.js';
import * as game from './module/game.js';
import * as music from './module/music.js';
import * as role from "./module/role.js";
import * as taoke from "./module/taoke.js";
import * as reader from "./module/reader.js";
import * as activity from "./module/activity.js";
    
const modules = {
    app,
    user,
    robot,
    article,
    survey,
    game,
    music,
    role,
    taoke,
    reader,
    activity
};

let api = {};

for(let k in modules) {
	
	for(let i in modules[k]) {
		let item = modules[k][i];
		api[i] = item;
	}
	
}


const install = Vue => {
    if (install.installed) {
		return;
	}

    install.installed = true;
    Object.defineProperties(Vue.prototype, {
        $api: {
            get() {
                return api;
            }
        }
    });
};

export default install;



// WEBPACK FOOTER //
// ./src/api/index.js